<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script setup>
	import {onMounted} from "vue";
	const isMobile = () => {
		const flag = navigator.userAgent.match(
			/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
		);
		if (flag) {
			let url = "www.thklyq.cn/mobile.html";
			let path = window.location.protocol + "//" + url;
			window.location = path;
		}
	};
	onMounted(() => {
		isMobile()
	})
</script>
<style lang="less">
*{
	margin: 0;
	padding: 0;
}
body::-webkit-scrollbar {
	/*隐藏滚轮*/
	display: none;
}
/* 隐藏垂直滚动条 */
.middle::-webkit-scrollbar {
  width: 0;
}
 
/* 隐藏水平滚动条 */
.middle::-webkit-scrollbar {
  height: 0;
}
#app{
	cursor:pointer;
	background-color: #fff;
}
@font-face {
	font-family: 'fz';
	src: url('assets/方正藏文新白体_Unicode.TTF');
}
@font-face {
	font-family: 'hm';
	src: url('assets/HIMALAYA-E.TTF');
}
@font-face {
	font-family: 'BibleScrT';
	src: url('assets/BibleScrT.ttf');
}
.all_img{
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: 0.5s all;
}
	/*了解天河口*/
	.about{
		width: 1920px;
		min-height: 100vh;
		position: relative;
		padding-top: 1px;
		background-color: #eff4f4;
	}
	.bgboxf{
		width: 100%;
		height: 700px;
	}
	.bgbox {
	    width: 100%;
	    height: 100vh;
		position: fixed;
		z-index: 0;
	    background-repeat: no-repeat;
	    background-size: 100% 100%;
	    display: flex;
	    justify-content: center;
	    align-items: center;
		background-image: url('@/static/about/about-bg.png');
	}
	.icon-image{
		background-image: url('@/static/about/about-icon.png');
		background-repeat: no-repeat;
		background-size: 100% ;
		width: 489px;
		height: 489px;
		margin: 0 auto;
		position: relative;
	}
	.mycontent{
		display: flex;
		flex-direction: column;
		width: 100%;
		background-image: url('@/static/about/page-bottom-bg.png');
		background-size: 100% auto;
		background-repeat: no-repeat;
		background-position: bottom center;
		position: relative;
		z-index: 1;
		background-color: #eff4f4;
	}
	.mycontent::before{
		content: '';
		width: 100%;
		height: 220px;
		position: absolute;
		top:-220px;
		background-image: url('@/static/about/page-top-bg.png');
		background-color: transparent;
		background-size: 100% auto;
		background-repeat: no-repeat;
		background-position: top center;
	}
	.middle{
		width: 1200px;
		margin:0 auto;
		overflow: auto;
		padding-bottom: 245px;
	}

	.lebg{
		width: 300px;
		height: 76px;
		position: absolute;
		top: -34px;
		left: 0;
	}
	.zsxb {
		width: 173px;
		height: 221px;
		position: absolute;
		left: 50%;
		top: -86px;
		transform: translateX(-50%);
	}
	/*内页菜单*/
	.menu-list{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		overflow: hidden;
		margin-top: 50px;
		z-index: 9999;
		position: absolute;
		top:-220px;
	}
	.menu-list .item{
		display: flex;
		margin: 0 40px;
		flex-direction: column;
		align-items: center;
	}
	.item-box{
		border: 1px solid #999999;
		width: 4.5vw;
		height: 4.5vw;
		border-radius: 1.45vw;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.item-text{
		font-size: 14px;
		width: 4vw;
		height: 4vw;
		border: 1px solid #999999;
		background-color: #f1f6f6;
		border-radius: 1.45vw;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #333333;
		position: relative;
	}
	.item-text .text{
		min-width: 4.5vw;
		height: 1.2vw;
		text-align: center;
		background-color: #f1f6f6;
	}
	.menu-list .item:hover,.menu-list .active{
		.line-box {
		    border-right: 1px #59b75a dashed;
		    height: 4.4vw;
		}
		.item-box{
			border: 1px solid #59b75a;
			background-color: #59b75a;
		}
		.item-text{
			color: #ffffff;
			border: 1px solid rgba(255, 255, 255, 0.5);
			background-color: #59b75a;
		}
		.item-text .text{
			text-align: center;
			background-color: #59b75a;
		}
	}
	.line-box {
	    height: 3vw;
		width: 1px;
	    border-right: 1px dashed #999999;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    transition: all .6s;
	}
	.line-ball {
	   min-width: .5vw;
	   height: .5vw;
	   background-color: #fff;
	   border: 1px solid #999999;
	   transform: rotate(45deg) translateX(2px);
	}
	.mid_right{
		width: 1200px;
		margin: 0 auto;
		margin-top: 10px;
		padding: 20px;
		min-height: 500px;
		position: relative;
		top:20px;
		box-sizing: border-box;
		background-color: #ffffff;
	}
	.contenttitlebox{
		width: 100%;
		text-align: center;
		color: #59b75a;
		margin:10px 0 20px 0;
	}
	.son_chnavnametemplet {
	    font-size: 1.56vw;
	}
	.son_ennavname {
	    font-family: 'BibleScrT';
	    font-size: 1.25vw;
	    letter-spacing: .1vw;
	    margin-top: .2vw;
		text-transform:capitalize;
	}
	.det_title{
		height: 70px;
		text-align: center;
		font-size: 30px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.details{
		color: #333333;
		img{
			display: block;
			max-width: 90%;
			margin: auto;
			margin-top: 10px;
			margin-bottom: 10px;
		}
	}
	//
	.anniubox{
		margin-top: 50px;
		display: flex;
		justify-content: center;
	}
	.anniu{
		width: 110px;
		height: 40px;
		line-height: 40px;
		border-radius: 17.5px;
		text-align: center;
		font-size: 16px;
		color: #f9c026;
		background-color: #3b51b7;
		margin:  0 25px;
	}
	.anniu:hover{
		color: #333333;
		background-color: #f9c026;
	}

    .detail-pages {
    	display: flex;
    	width: 95%;
    	margin: 0 auto;
    	justify-content: space-between;
    	margin-top: 15px;
    	.item {
    		cursor: pointer;
    	}
    }
	.transition:hover {
		transform: scale(1.1);
		-webkit-transition: all 1s;
		-moz-transition: all 1s;
		-ms-transition: all 1s;
		-o-transition: all 2s;
		transition: all 2s;
	}
</style>
